import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 13L1 7L7 1", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgLeft);
const Memo = memo(ForwardRef);
export default Memo;
